import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useFetchPromise } from '@rad/hooks';
import { findExploreCategory } from '../../common/explore-filters';
import { getExploreCategories } from '../../common/network/explore-category';
import Hero from './components/hero/hero';
import ExplorePanel from './components/home/explore-panel';
import FeaturedPropertySection from './components/home/featured-property-section';
import NearbyPropertiesSection from './components/home/nearby-properties-section';
import RoleExplorerSection from './components/home/role-explorer-section';
import PartnershipsSection from './components/home/partnerships-section';
import JoinBand from './components/home-outro/join-band';
import NewsletterBand from './components/home-outro/newsletter-band';
const HomeV2 = (props) => {
    const [categories] = useFetchPromise(getExploreCategories());
    const [categoryName, setCategoryName] = React.useState(null);
    const activePillRef = React.useRef(null);
    const category = findExploreCategory(categories !== null && categories !== void 0 ? categories : [], categoryName);
    // Clicking the open category closes the map; any other switches the filter.
    const toggleCategory = (next) => setCategoryName(current => current === next ? null : next);
    // The panel's collapse button unmounts itself, so hand focus back to the pill
    // that opened it rather than letting it fall to the document.
    const collapse = () => {
        var _a;
        setCategoryName(null);
        (_a = activePillRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    return (_jsxs(_Fragment, { children: [_jsx(Hero, { categories: categories !== null && categories !== void 0 ? categories : [], activeCategory: categoryName, onToggleCategory: toggleCategory, activePillRef: activePillRef }), category === null
                ? null
                : _jsx(ExplorePanel, { category: category, onCollapse: collapse }), _jsx(NearbyPropertiesSection, {}), _jsx(FeaturedPropertySection, {}), _jsx(RoleExplorerSection, {}), _jsx(PartnershipsSection, {}), _jsx(JoinBand, {}), _jsx(NewsletterBand, {})] }));
};
export default HomeV2;
